import getIsSubchapter from "selectors/getIsSubchapter";
import getIsSubchapterRenderedSomewhere from "selectors/routing/getIsSubchapterRenderedSomewhere";
import { createSelector } from "reselect";

const getHasSubchapter = createSelector(
  [getIsSubchapter, getIsSubchapterRenderedSomewhere],
  (isSubchapter, isSubchapterRenderedSomewhere) =>
    isSubchapterRenderedSomewhere && !isSubchapter,
);

export default getHasSubchapter;
